import _slicedToArray from "/codebuild/output/src2483311815/src/git-codecommit.eu-west-1.amazonaws.com/v1/repos/sfx_itransfer_agent_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "/codebuild/output/src2483311815/src/git-codecommit.eu-west-1.amazonaws.com/v1/repos/sfx_itransfer_agent_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import React__default, { useReducer, useContext, createContext } from 'react';
import { _ as _objectSpread2 } from './_rollupPluginBabelHelpers-05128ded.js';
import { f as VOICE_PLAYER_ROOT_ID, g as VOICE_PLAYER_AUDIO_ID, b as VOICE_MESSAGE_FILE_NAME, c as VOICE_MESSAGE_MIME_TYPE } from './consts-fa6ab3c0.js';
import useSendbirdStateContext from './useSendbirdStateContext.js';
var INITIALIZE_AUDIO_UNIT = 'INITIALIZE_AUDIO_UNIT';
var SET_CURRENT_PLAYER = 'SET_CURRENT_PLAYER';
var ON_VOICE_PLAYER_PLAY = 'ON_VOICE_PLAYER_PLAY';
var ON_VOICE_PLAYER_PAUSE = 'ON_VOICE_PLAYER_PAUSE';
var ON_CURRENT_TIME_UPDATE = 'ON_CURRENT_TIME_UPDATE';
var VOICE_PLAYER_STATUS = {
  IDLE: 'IDLE',
  PREPARING: 'PREPARING',
  PLAYING: 'PLAYING',
  PAUSED: 'PAUSED',
  COMPLETED: 'COMPLETED'
};
var AudioUnitDefaultValue = function AudioUnitDefaultValue() {
  return {
    audioFile: null,
    playbackTime: 0,
    duration: 1000,
    playingStatus: VOICE_PLAYER_STATUS.IDLE
  };
};
var voicePlayerInitialState = {
  currentPlayer: null,
  currentGroupKey: '',
  audioStorage: {}
};
function voicePlayerReducer(state, action) {
  switch (action.type) {
    case INITIALIZE_AUDIO_UNIT:
      {
        var _state$audioStorage;
        var groupKey = action.payload.groupKey;
        var audioUnit = (_state$audioStorage = state.audioStorage) !== null && _state$audioStorage !== void 0 && _state$audioStorage[groupKey] ? state.audioStorage[groupKey] : AudioUnitDefaultValue();
        audioUnit.playingStatus = VOICE_PLAYER_STATUS.PREPARING;
        return _objectSpread2(_objectSpread2({}, state), {}, {
          audioStorage: _objectSpread2(_objectSpread2({}, state.audioStorage), {}, _defineProperty({}, groupKey, audioUnit))
        });
      }
    case SET_CURRENT_PLAYER:
      {
        var _action$payload = action.payload,
          audioPlayer = _action$payload.audioPlayer,
          _groupKey = _action$payload.groupKey;
        return _objectSpread2(_objectSpread2({}, state), {}, {
          currentPlayer: audioPlayer,
          currentGroupKey: _groupKey
        });
      }
    case ON_VOICE_PLAYER_PLAY:
      {
        var _state$audioStorage2;
        var _action$payload2 = action.payload,
          _groupKey2 = _action$payload2.groupKey,
          audioFile = _action$payload2.audioFile;
        var _audioUnit = (_state$audioStorage2 = state.audioStorage) !== null && _state$audioStorage2 !== void 0 && _state$audioStorage2[_groupKey2] ? state.audioStorage[_groupKey2] : AudioUnitDefaultValue();
        _audioUnit.audioFile = audioFile;
        _audioUnit.playingStatus = VOICE_PLAYER_STATUS.PLAYING;
        return _objectSpread2(_objectSpread2({}, state), {}, {
          audioStorage: _objectSpread2(_objectSpread2({}, state.audioStorage), {}, _defineProperty({}, _groupKey2, _audioUnit))
        });
      }
    case ON_VOICE_PLAYER_PAUSE:
      {
        var _state$audioStorage3;
        var _groupKey3 = action.payload.groupKey;
        var _audioUnit2 = (_state$audioStorage3 = state.audioStorage) !== null && _state$audioStorage3 !== void 0 && _state$audioStorage3[_groupKey3] ? state.audioStorage[_groupKey3] : AudioUnitDefaultValue();
        _audioUnit2.playingStatus = VOICE_PLAYER_STATUS.PAUSED;
        var _state$currentPlayer = state.currentPlayer,
          currentTime = _state$currentPlayer.currentTime,
          duration = _state$currentPlayer.duration;
        if (_audioUnit2.playbackTime === _audioUnit2.duration) {
          _audioUnit2.playbackTime = 0;
        } else if (currentTime > 0 && duration > 0) {
          _audioUnit2.playbackTime = currentTime;
          _audioUnit2.duration = duration;
        }
        return _objectSpread2(_objectSpread2({}, state), {}, {
          audioStorage: _objectSpread2(_objectSpread2({}, state.audioStorage), {}, _defineProperty({}, _groupKey3, _audioUnit2))
        });
      }
    case ON_CURRENT_TIME_UPDATE:
      {
        var _state$audioStorage4;
        var _groupKey4 = action.payload.groupKey;
        var _state$currentPlayer2 = state.currentPlayer,
          _currentTime = _state$currentPlayer2.currentTime,
          _duration = _state$currentPlayer2.duration;
        var _audioUnit3 = (_state$audioStorage4 = state.audioStorage) !== null && _state$audioStorage4 !== void 0 && _state$audioStorage4[_groupKey4] ? state.audioStorage[_groupKey4] : AudioUnitDefaultValue();
        if (_currentTime > 0 && _duration > 0) {
          _audioUnit3.playbackTime = _currentTime;
          _audioUnit3.duration = _duration;
        }
        return _objectSpread2(_objectSpread2({}, state), {}, {
          audioStorage: _objectSpread2(_objectSpread2({}, state.audioStorage), {}, _defineProperty({}, _groupKey4, _audioUnit3))
        });
      }
    default:
      return state;
  }
}

// VoicePlayerProvider interface

var ALL = 'ALL';
var noop = function noop() {/* noop */};
var VoicePlayerStoreDefaultValue = {
  currentGroupKey: '',
  currentPlayer: null,
  audioStorage: {}
};
var Context = /*#__PURE__*/createContext({
  play: noop,
  pause: noop,
  stop: noop,
  voicePlayerStore: VoicePlayerStoreDefaultValue
});
var VoicePlayerProvider = function VoicePlayerProvider(_ref) {
  var children = _ref.children;
  var _useReducer = useReducer(voicePlayerReducer, voicePlayerInitialState),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    voicePlayerStore = _useReducer2[0],
    voicePlayerDispatcher = _useReducer2[1];
  var currentGroupKey = voicePlayerStore.currentGroupKey,
    currentPlayer = voicePlayerStore.currentPlayer,
    audioStorage = voicePlayerStore.audioStorage;
  var _useSendbirdStateCont = useSendbirdStateContext(),
    config = _useSendbirdStateCont.config;
  var logger = config.logger;
  var stop = function stop() {
    var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    if (currentGroupKey.includes(text)) {
      logger.info('VoicePlayer: Pause playing(by text).');
      pause(currentGroupKey);
    }
  };
  var pause = function pause(groupKey) {
    if (currentGroupKey === groupKey && currentPlayer !== null) {
      logger.info('VoicePlayer: Pause playing(by group key).');
      currentPlayer === null || currentPlayer === void 0 ? void 0 : currentPlayer.pause();
    }
    if (groupKey === ALL) {
      logger.info('VoicePlayer: Pause playing(all).');
      currentPlayer === null || currentPlayer === void 0 ? void 0 : currentPlayer.pause();
    }
  };
  var play = function play(_ref2) {
    var groupKey = _ref2.groupKey,
      _ref2$audioFile = _ref2.audioFile,
      audioFile = _ref2$audioFile === void 0 ? null : _ref2$audioFile,
      _ref2$audioFileUrl = _ref2.audioFileUrl,
      audioFileUrl = _ref2$audioFileUrl === void 0 ? '' : _ref2$audioFileUrl;
    if (groupKey !== currentGroupKey) {
      pause(currentGroupKey);
    }

    // Clear the previous AudioPlayer element
    var voicePlayerRoot = document.getElementById(VOICE_PLAYER_ROOT_ID);
    var voicePlayerAudioElement = document.getElementById(VOICE_PLAYER_AUDIO_ID);
    if (voicePlayerAudioElement) {
      voicePlayerRoot.removeChild(voicePlayerAudioElement);
    }
    logger.info('VoicePlayer: Start getting audio file.');
    new Promise(function (resolve) {
      var _audioStorage$groupKe;
      voicePlayerDispatcher({
        type: INITIALIZE_AUDIO_UNIT,
        payload: {
          groupKey: groupKey
        }
      });
      // audio file passed as a parameter
      if (audioFile) {
        logger.info('VoicePlayer: Use the audioFile instance.');
        resolve(audioFile);
        return;
      }
      // audio file from the audioStorage
      var cachedAudioFile = audioStorage === null || audioStorage === void 0 ? void 0 : (_audioStorage$groupKe = audioStorage[groupKey]) === null || _audioStorage$groupKe === void 0 ? void 0 : _audioStorage$groupKe.audioFile;
      if (cachedAudioFile) {
        logger.info('VoicePlayer: Get from the audioStorage.');
        resolve(cachedAudioFile);
        return;
      }
      // fetch the audio file from URL
      fetch(audioFileUrl).then(function (res) {
        return res.blob();
      }).then(function (blob) {
        var audioFile = new File([blob], VOICE_MESSAGE_FILE_NAME, {
          lastModified: new Date().getTime(),
          type: VOICE_MESSAGE_MIME_TYPE
        });
        resolve(audioFile);
        logger.info('VoicePlayer: Get the audioFile from URL.');
      });
    }).then(function (audioFile) {
      var _URL, _URL$createObjectURL;
      var voicePlayerRoot = document.getElementById(VOICE_PLAYER_ROOT_ID);
      logger.info('VoicePlayer: Succeeded getting audio file.', {
        audioFile: audioFile
      });
      var currentAudioUnit = audioStorage[groupKey] || AudioUnitDefaultValue();
      var audioPlayer = new Audio((_URL = URL) === null || _URL === void 0 ? void 0 : (_URL$createObjectURL = _URL.createObjectURL) === null || _URL$createObjectURL === void 0 ? void 0 : _URL$createObjectURL.call(_URL, audioFile));
      audioPlayer.id = VOICE_PLAYER_AUDIO_ID;
      audioPlayer.currentTime = currentAudioUnit.playbackTime;
      audioPlayer.volume = 1;
      audioPlayer.loop = false;
      audioPlayer.onplaying = function () {
        logger.info('VoicePlayer: OnPlaying event is called from audioPlayer', {
          groupKey: groupKey,
          audioPlayer: audioPlayer
        });
        voicePlayerDispatcher({
          type: ON_VOICE_PLAYER_PLAY,
          payload: {
            groupKey: groupKey,
            audioFile: audioFile
          }
        });
      };
      audioPlayer.onpause = function () {
        logger.info('VoicePlayer: OnPause event is called from audioPlayer', {
          groupKey: groupKey,
          audioPlayer: audioPlayer
        });
        voicePlayerDispatcher({
          type: ON_VOICE_PLAYER_PAUSE,
          payload: {
            groupKey: groupKey
          }
        });
      };
      audioPlayer.ontimeupdate = function () {
        voicePlayerDispatcher({
          type: ON_CURRENT_TIME_UPDATE,
          payload: {
            groupKey: groupKey
          }
        });
      };
      audioPlayer.dataset.sbGroupId = groupKey;
      // clean up the previous audio player
      try {
        voicePlayerRoot === null || voicePlayerRoot === void 0 ? void 0 : voicePlayerRoot.childNodes.forEach(function (node) {
          var _element$dataset;
          var element = node;
          var thisGroupKey = (_element$dataset = element.dataset) === null || _element$dataset === void 0 ? void 0 : _element$dataset.sbGroupKey;
          if (thisGroupKey !== groupKey) {
            var _element$pause;
            element === null || element === void 0 ? void 0 : (_element$pause = element.pause) === null || _element$pause === void 0 ? void 0 : _element$pause.call(element);
            voicePlayerDispatcher({
              type: ON_VOICE_PLAYER_PAUSE,
              payload: {
                groupKey: groupKey
              }
            });
            voicePlayerRoot.removeChild(element);
            logger.info('VoicePlayer: Removed other player.', {
              element: element
            });
          }
        });
      } finally {
        audioPlayer === null || audioPlayer === void 0 ? void 0 : audioPlayer.play();
        voicePlayerRoot === null || voicePlayerRoot === void 0 ? void 0 : voicePlayerRoot.appendChild(audioPlayer);
        voicePlayerDispatcher({
          type: SET_CURRENT_PLAYER,
          payload: {
            groupKey: groupKey,
            audioPlayer: audioPlayer
          }
        });
        logger.info('VoicePlayer: Succeeded playing audio player.', {
          groupKey: groupKey,
          audioPlayer: audioPlayer
        });
      }
    });
  };
  return /*#__PURE__*/React__default.createElement(Context.Provider, {
    value: {
      play: play,
      pause: pause,
      stop: stop,
      voicePlayerStore: voicePlayerStore
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    id: VOICE_PLAYER_ROOT_ID,
    style: {
      display: 'none'
    }
  }), children);
};
var useVoicePlayerContext = function useVoicePlayerContext() {
  return useContext(Context);
};
export { ALL as A, VoicePlayerProvider as V, VOICE_PLAYER_STATUS as a, AudioUnitDefaultValue as b, useVoicePlayerContext as u };